import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { DEFAULT_SITE_CONTENT, CLINIC } from "../data/content";

export const mergeContent = (def, ov) => {
  if (!ov) return def;
  const out = { ...def };
  for (const k of Object.keys(ov)) {
    if (ov[k] && typeof ov[k] === "object" && !Array.isArray(ov[k])) {
      out[k] = mergeContent(def?.[k] || {}, ov[k]);
    } else if (ov[k] !== undefined && ov[k] !== null && ov[k] !== "") {
      out[k] = ov[k];
    }
  }
  return out;
};

const Ctx = createContext({
  ...DEFAULT_SITE_CONTENT,
  clinic: { ...CLINIC, ...DEFAULT_SITE_CONTENT.clinic },
});

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_SITE_CONTENT);

  useEffect(() => {
    api
      .get("/site-content")
      .then(({ data }) => setContent(mergeContent(DEFAULT_SITE_CONTENT, data)))
      .catch(() => {});
  }, []);

  const clinic = {
    ...CLINIC,
    ...content.clinic,
    phoneHref: "tel:+" + (content.clinic.phone || CLINIC.phone).replace(/\D/g, ""),
  };

  return <Ctx.Provider value={{ ...content, clinic }}>{children}</Ctx.Provider>;
}

export const useSiteContent = () => useContext(Ctx);
